import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteAppointment, AthleteKiloClassManualCredit, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type ManualCreditAthleteAppointmentVars = {
  athleteAppointmentId: string;
  manualCredit: AthleteKiloClassManualCredit;
};

export default function useManualCreditAthleteAppointment(): UseMutationResult<
  AxiosResponse<AthleteAppointment>,
  AxiosError<ErrorMessage>,
  ManualCreditAthleteAppointmentVars
> {
  const queryClient = useQueryClient();

  const manualCreditAthleteAppointment = ({
    athleteAppointmentId,
    manualCredit,
  }: ManualCreditAthleteAppointmentVars): Promise<AxiosResponse<AthleteAppointment>> => {
    return client.put(`athlete-appointments/${athleteAppointmentId}/credit/`, manualCredit);
  };

  return useMutation(manualCreditAthleteAppointment, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteAppointments'],
      });
      queryClient.invalidateQueries({
        queryKey: ['appointments'],
      });
      queryClient.invalidateQueries({
        queryKey: 'events',
      });
      queryClient.invalidateQueries({
        queryKey: ['totalAttended'],
      });
      queryClient.invalidateQueries({
        queryKey: ['totalReserved'],
      });
    },
  });
}
